<template>
  <div>
    <div class="router-header flex flex-wrap items-center mb-3">
      <div class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light">
      </div>
    </div>
    <div class="vx-row">
      <div
        v-for="comp in inProgress"
        :key="comp.id"
        class="vx-col w-full"
      >
        <a :href="constants.url + '/user/skill-details/' + comp.i" target="_blank">
          <div class="vx-card overflow-hidden mb-2">
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div>
                <div class="p-4 flex items-center justify-start text-left">
                  
                  <!-- Relative wrapper -->
                  <div style="position: relative; display: inline-flex;">
                    <span
                      class="inline-flex rounded-full select-none text-primary mc-icon"
                      style="background: rgba(var(--vs-primary),0.15); width: 54px; height: 54px; display: flex; align-items: center; justify-content: center;"
                    >
                      <img :src="comp.icon" alt="" width="30px" height="30px" />
                    </span>

                    <!-- EXACT HOME.VUE LOGIC: Show yellow dot if !== 1 -->
                    <span 
                      v-if="comp.motivationSurvey !== 1"
                      class="custom-status-dot warning" 
                      :title="comp.motivationSurvey === 2 ? $t('playerJourney.t3_2') : $t('playerJourney.t3_3')"
                    ></span>
                  </div>

                  <div class="truncate ml-4 flex-grow text-left">
                    <h5 class="mb-0 text-left font-semibold">{{ comp.comp }}</h5>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import ccd from "@/assets/data/charactersistic-competency-definition";
import constants from "../../../../constants.js";

// Store Module
// import moduleAddSkill from "@/store/add-skill/moduleCompetencyProgress.js";

export default {
  name: "MySkills",
  props: ['inProgress'],
  data() {
    return {
      allCompetencies: [],
      CCD: this.$t("addNewSkill.data"),
      constants
    };
  },
  created() {},
  methods: {
    getSkillDetailsUrl(competencyId) {
    let url = `${this.constants.url}/user/skill-details/${competencyId}`;
    if (this.traineeName) {
      // Append mentorView=true to explicitly flag this as a mentor navigation
      url += `?traineeName=${encodeURIComponent(this.traineeName)}&mentorView=true`;
    }
    return url;
  }

  },
  mounted() {}
};
</script>

<style scoped>
.vx-card {
  cursor: pointer;
}

.vx-card:hover {
  background: #F9F9F9;
}

.competency-img {
  width: 30px;
  height: 30px;
  margin: auto;
}

.selectedCompetency {
  background: #9dcd5b! important;
  color: white! important;
}

.selected-competency .competency-title h4 {
  color: white;
}

.not-selected-competency {
}

.con-vs-card >>> .vs-card--content {
  padding: 3px 8px 3px 8px !important;
  margin-bottom: 10px;
}

.truncate {
  white-space: normal !important;
}

.truncate h5 {
  margin-left: 0 !important; 
}

.truncate span {
  display: none;
}

/* --- ADD THESE CLASSES FOR THE DOT --- */
.custom-status-dot {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1.5px solid #ffffff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.25);
  z-index: 10;
}

.custom-status-dot.warning {
  background-color: #FBBF15 !important; /* Bright Yellow */
}

.custom-status-dot.primary {
  background-color: rgba(var(--vs-primary), 1) !important;
}

.custom-status-dot.grey {
  background-color: #b8c2cc !important; /* Grey neutral color */
}

.selectedCompetency >>> span.mc-icon {
  background: #fff !important;
}

.selectedCompetency .truncate span {
  display: block !important;
}

.selectedCompetency .truncate h5 {
  color: white;
}
</style>
